export const themes = {
  default: ({ isActive }) => ({
    thRoot: `reset-button cursor-pointer flex flex-col sm:flex-row items-center p-1 rounded-small text-sm transition-colors${
      isActive ? ' bg-blue hover:bg-turquoise text-white' : ' hover:text-turquoise'
    }`,
    thIcon: 'm-1 flex-shrink-0',
    thIconWidth: '1.25rem',
    thLabel: 'a11y mx-1',
  }),
  custom: ({ isActive }) => ({
    thRoot: `reset-button cursor-pointer flex flex-col sm:flex-row items-center p-1 rounded-small text-sm transition-colors${
      isActive ? ' bg-blue hover:bg-turquoise text-white' : ' hover:text-turquoise'
    }`,
    thIcon: 'm-1 flex-shrink-0',
    thIconWidth: '1.25rem',
    thLabel: 'm-1 text-center text-md',
  }),
};
